import { arrayOf, func, shape } from "prop-types";
import { useMemo } from "react";

import Reservation from "web/Pages/Checkout/TourismDomestic/SharedComponents/Reservation";

import __ from "web/Layout/Translations";

import Box from "web/Components/Common/Box";
import HtmlTemplate from "web/Components/Common/HtmlTemplate";
import PaymentSummary from "web/Components/Common/PaymentSummary";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import Contacts from "../../TourismDomestic/SharedComponents/Contacts";
import classes from "./tourismSuccess.scss";

const TourismSuccess = ({ order, sources, setSourcesOpen }) => {
  const {
    email,
    phone,
    site,
    guests,
    purchaser,
    rooms,
    dateFrom,
    dateTo,
    total,
    paid,
    price,
    purchaserOnly,
    objectRules,
  } = useMemo(() => {
    if (order) {
      const [productData, tourismOfferData] =
        isArrayHasItems(order.items) && order.items[0]
          ? [order.items[0].product_data, order.items[0].tourism_offer_data]
          : [];

      const productPrice = order.items[0].price;

      const paidAmount = order?.payments
        ? order.payments
            .map((item) => item.amount_ordered)
            .reduce((a, b) => a + b, 0)
        : order?.payment.map((item) => +item.to_pay).reduce((a, b) => a + b, 0);
      return productData
        ? {
            email: productData.tourism_email,
            phone: productData.tourism_phone,
            site: productData.tourism_website,
            guests: order.tourism_data && order.tourism_data.guest,
            purchaser: order.tourism_data && order.tourism_data.purchaser,
            rooms: tourismOfferData.room,
            dateFrom: Date.parse(tourismOfferData.date_from),
            dateTo: Date.parse(tourismOfferData.date_to),
            total: +order.total || 0,
            paid: paidAmount,
            price: productPrice,
            purchaserOnly: order.tourism_data?.purchaser_only,
            objectRules: productData.tourism_object_rules,
          }
        : {};
    }
    return {};
  }, [JSON.stringify(order)]);

  return (
    <>
      <PaymentSummary
        total={total}
        paid={paid}
        setSourcesOpen={setSourcesOpen}
        sources={sources}
        orderState={order.state}
      />
      <Reservation
        price={price}
        guests={purchaserOnly ? [] : guests}
        purchaser={purchaser}
        rooms={rooms}
        dateFrom={dateFrom}
        dateTo={dateTo}
        title={__("Rezerwacja")}
      />

      {/* object rules */}
      {objectRules && (
        <Box
          headingTag="h2"
          headingText={__("Zasady obiektu")}
          sectionClass={classes.objectRules}
        >
          <HtmlTemplate
            template={objectRules}
            className={classes.objectRules__content}
          />
        </Box>
      )}

      {email || phone || site ? (
        <Contacts phone={phone} email={email} site={site} />
      ) : null}
    </>
  );
};

TourismSuccess.defaultProps = {
  setSourcesOpen: () => {},
  sources: [],
};

TourismSuccess.propTypes = {
  sources: arrayOf(shape({})),
  setSourcesOpen: func,
  order: shape({}).isRequired,
};

export default TourismSuccess;
